export { default as SliderInput } from './input'
